<template>
  <div class="deposit-coin">
    <div class="title">
      Nạp Tiền Điện Tử {{ getInfo ? getInfo.Currency_Name : "" }}
    </div>
    <div class="qr-code">
      <img :src="Deposit.qr" alt="" :key="Deposit.qr" />
    </div>
    <div class="coin-address">
      <div class="box-address mb-1">
        <span>Địa Chỉ Ví Nạp</span>
        <div class="address-wallet">
          <b-input-group class="">
            <template #prepend>
              <b-input-group-text>
                <b-button
                  v-clipboard:copy="Deposit.address"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  Sao Chép
                </b-button>
              </b-input-group-text>
            </template>
            <b-form-input
              type="text"
              required
              v-model="Deposit.address"
              readonly
            ></b-form-input>
          </b-input-group>
        </div>
      </div>
    </div>
    <div class="coin-warning mt-4 text-warning">
      Chúng tôi chỉ nhận {{ getInfo ? getInfo.Currency_Name : "" }} đến địa chỉ
      ví này. Nếu bạn gửi một loại tiền khác hoặc token khác đến địa chỉ này,
      bạn có thể có nguy cơ mất tiền
    </div>
    <div class="button-close text-center my-4">
      <b-button variant="primary" @click="closePopup">Xác Nhận</b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filter from "lodash/filter";

export default {
  props: {
    CoinID: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      coin: null,
      address: "",
    };
  },
  computed: {
    ...mapGetters({
      Coin: "wallet/Coin",
      Deposit: "wallet/Deposit",
    }),
    getInfo() {
      return filter(this.Coin, (elm) => elm.Currency_ID === this.coin)[0];
    },
  },
  methods: {
    getCoin() {
      this.$store.dispatch("wallet/req_getDepositInfo", {
        coin: this.coin,
      });
    },
    onCopy() {
      this.$toastr.s("Sao chép địa chỉ ví thành công");
    },
    onError() {
      this.$toastr.e("Sao chép địa chỉ ví thất bại");
    },
    closePopup() {
      this.$emit("closePopup", true);
    },
  },
  async mounted() {
    this.coin = this.CoinID;
    this.$store.dispatch("wallet/req_getDepositInfo", {
      coin: this.coin,
    });
  },
  created() {},
};
</script>

<style lang="scss">
.deposit-coin {
  max-width: 425px;
  margin: auto;
  .qr-code {
    text-align: center;
    margin-top: 15px;
    img {
      max-width: 215px;
      margin: auto;
      width: 100%;
    }
  }
  .title {
    font-weight: 600;
    font-size: clamp(16px, 2vw, 18px);
    color: #ffff;
    text-align: center;
    padding: 15px 25px;
    box-shadow: 0 0.75rem 1.5rem rgb(0, 0, 0, 0.28);
    background: linear-gradient(to bottom, #008cff, #003395);
    margin-bottom: 25px;
  }
  .coin-address {
    padding: 0 25px;
  }
  .button-close {
    button {
      font-weight: 600;
    }
  }
  .coin-warning {
    padding: 0 25px;
    text-align: center;
    margin-top: 10px;
    font-weight: 600;
    font-size: clamp(14px, 2vw, 16px);
  }
  label {
    font-size: clamp(14px, 2vw, 16px);
    color: #fff;
    font-weight: 600;
    margin-bottom: 5px;
    margin-top: 15px;
  }
  .box-address {
    width: 100%;
    margin-top: 20px;
    span {
      font-size: clamp(14px, 2vw, 16px);
      color: #fff;
      font-weight: 600;
      margin-bottom: 5px;
    }
    .address-wallet {
      margin-top: 2px;
      background: #556de669;
      border-radius: 5px;
      height: 40px;
      .input-group-text {
        padding: 0;
        border: 0;
        button {
          width: 90px;
          height: 40px;
          padding: 0;
          background: #556ee6;
          color: #fff !important;
          border: 0;
          outline: none;
          border-radius: 5px;
          box-shadow: 0px 0px 5px 1px #0000009e;
          font-weight: 600;
        }
      }
      input {
        height: 40px;
        border: 0;
        background: transparent;
        color: #fff;
        font-weight: 600;
        &:hover,
        &:focus,
        &:focus-visible {
          outline: none;
          box-shadow: none;
          border: 0;
        }
      }
    }
  }
}
</style>
